// styles.
import { FooterContainer } from "../styles/features/FooterStyles";

export const Footer: React.FC = () => {
  return (
    <FooterContainer className="footer">
      <p>&copy; 2024 GearWeb Solutions. Todos los derechos reservados</p>
      <p>. Icons by Icons8. Imágenes diseñadas por Freepik.</p>
    </FooterContainer>
  );
};
